const USER_ROLES = {
  ADMIN: 'admin',
  SCHOOL_GROUP_ADMIN: 'school-group-admin',
  DISTRICT_ADMIN: 'district-admin',
  CAMPUS_GROUP_ADMIN: 'campus-group-admin',
};

export const hasSchoolGroup = (user?: { schoolGroupId?: number | null; school_group_id?: number | null }) => {
  if (!user) return false;
  const schoolGroupId = user.schoolGroupId ?? user.school_group_id;
  return Boolean(schoolGroupId);
};

export const isInternalEmail = (email?: string | null): boolean => {
  if (!email) return false;
  return email.endsWith('@beeverso.org') || email.endsWith('@beereaders.com');
};

export default USER_ROLES;
